import { safeUrl } from "@/lib/media";

/** Category cards on the home page. The admin can replace each photo in Settings → Home page pictures. */
export const CATEGORIES = [
    { name: "Presidential Properties", desc: "Ultra-luxury sky homes & sea-view residences.", image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750" },
    { name: "Under Construction", desc: "Get in early on tomorrow's landmark projects.", image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3" },
    { name: "Ready to Move", desc: "Own it today. Move in this month.", image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c" },
];

// Built-in photos for the neighbourhoods we know about. Project counts come from the database, never from this file.
export const LOCATION_IMAGES = {
    "South Mumbai": "https://images.unsplash.com/photo-1595658658481-d53d3f999875",
    "Thane": "https://images.unsplash.com/photo-1580237072617-771c3ecc4a24",
    "Navi Mumbai": "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
    "Dombivli": "https://images.unsplash.com/photo-1600585152220-90363fe7e115",
    "Kalyan": "https://images.unsplash.com/photo-1512918728675-ed5a9ecdebfd",
};

/** The admin's uploaded photo if there is one, otherwise the built-in one. */
export const categoryImage = (settings, c) => safeUrl(settings?.category_images?.[c.name]) || c.image;
export const locationImage = (settings, name) => safeUrl(settings?.location_images?.[name]) || LOCATION_IMAGES[name] || "";
